import React from "react"
import { Helmet } from "react-helmet"

import OfferBase from "../../../components/offer"

const Offer = () => {
  return (
    <OfferBase offerTitle={'Stomatologia zachowawcza'}>
      <Helmet title={"Stomatologia zachowawcza - Dent&Beauty"} />
    </OfferBase>
  )
}

export default Offer
